import request from '@/utils/request'


// 查询模板规则列表
export function listReportTemplateDetail(query) {
    return request({
        url: '/biz/reportTemplateDetail/list',
        method: 'get',
        params: query
    })
}

// 查询模板规则列表
export function listReportTemplateDetailAll(query) {
    return request({
        url: '/biz/reportTemplateDetail/listAll',
        method: 'get',
        params: query
    })
}



// 查询模板规则详细
export function getReportTemplateDetail(id) {
    return request({
        url: '/biz/reportTemplateDetail/' + id,
        method: 'get'
    })
}

// 新增模板规则
export function addReportTemplateDetail(data) {
    return request({
        url: '/biz/reportTemplateDetail',
        method: 'post',
        data: data
    })
}

// 修改模板规则
export function updateReportTemplateDetail(data) {
    return request({
        url: '/biz/reportTemplateDetail/update',
        method: 'post',
        data: data
    })
}

// 删除模板规则
export function delReportTemplateDetail(id) {
    return request({
        url: '/biz/reportTemplateDetail/delete/' + id,
        method: 'post'
    })
}
